export const selectNodeCapabilitiesEntry = (state, id) => state.capabilities.byNode[id];
export const selectNodeCapabilities = (state, id) =>
  state.capabilities.byNode[id]?.data ?? null;

// The active node's row; unchanged meaning for callers that gate on "the" workspace.
export const selectCapabilities = (state) =>
  state.capabilities.activeId == null
    ? null
    : selectNodeCapabilities(state, state.capabilities.activeId);
export const selectCapabilitiesLoading = (state) =>
  state.capabilities.activeId == null
    ? false
    : Boolean(state.capabilities.byNode[state.capabilities.activeId]?.loading);
